
import PageTitle from '@/components/shared/PageTitle/index.vue'
import ModalViewer from '@/components/Base/ModelViewer/index.vue'
import ModalViewerStatic from '@/components/Base/ModelViewer/static.vue'
import services from '~/services'
import AboutOne from '~/components/Base/Abouts/AboutOne.vue'
import AboutTwo from '~/components/Base/Abouts/AboutTwo.vue'
import TechSpecs from '~/components/Base/Abouts/TechSpecs.vue'
import CtaOne from '~/components/Base/Ctas/CtaOne.vue'
import ServiceTwo from '~/components/Base/Services/ServiceTwo.vue'
import FeatureThree from '~/components/Base/Features/FeatureThree.vue'
import FeatureTwo from '~/components/Base/Features/FeatureTwo.vue'
import FeatureOne from '~/components/Base/Features/FeatureOne.vue'
import SliderTwo from '~/components/Base/Sliders/SliderTwo.vue'
import CompareOne from '~/components/Base/Compares/CompareOne.vue'
import AboutThree from '~/components/Base/Abouts/AboutThree.vue'
import AboutFour from '~/components/Base/Abouts/AboutFour.vue'
import SwiperOne from '~/components/Base/Swiper/SwiperOne.vue'
import VideoOne from '~/components/Base/Videos/video-one.vue'
import BannerThree from '~/components/Base/Banners/BannerThree.vue'
import ParallaxOne from '~/components/Base/Parallax/ParallaxOne.vue'
import GridContainerOne from '~/components/Base/GridContainer/GridContainerOne.vue'
import meta from '~/mixins/meta'
export default {
  mixins: [meta],
  components: {
    TechSpecs,
    PageTitle,
    BannerThree,
    ModalViewer,
    SwiperOne,
    CompareOne,
    CtaOne,
    AboutThree,
    AboutOne,
    AboutFour,
    AboutTwo,
    ServiceTwo,
    FeatureOne,
    FeatureTwo,
    FeatureThree,
    SliderTwo,
    VideoOne,
    ModalViewerStatic,
    GridContainerOne,
    ParallaxOne,
  },
  asyncData({ route, redirect }) {
    let product = null

    // get product by slug;
    const response = services.products.getBySlug(route.params.product)
    if (response.id) product = response
    else redirect('/not-found')
    // get producy by slug end
    return {
      product,
      meta: product?.meta,
      modelViewer: false,
      modelViewerLoaded: false,
    }
  },
  data() {
    return {
      scriptLoaded: false,
    }
  },
  methods: {
    descriptionHightlight(data, highlightDescriptionsArray) {
      highlightDescriptionsArray.forEach((item) => {
        data = data.replace(item, `<strong class="highlight">${item}</strong>`)
      })
      return data
    },
    loadScript(url) {
      return new Promise((resolve, reject) => {
        if (document.querySelector(`script[src="${url}"]`)) {
          resolve()
          return
        }

        const script = document.createElement('script')
        script.src = url
        script.type = 'module'
        script.async = true

        script.onload = () => {
          setTimeout(() => {
            this.modelViewerLoaded = true
            resolve()
          }, 500)
        }

        script.onerror = (error) => {
          reject(new Error(`Script load error: ${error}`))
        }

        document.body.appendChild(script)
      })
    },
    async initModelViewer() {
      if (process.client) {
        try {
          await this.loadScript(
            'https://ajax.googleapis.com/ajax/libs/model-viewer/3.5.0/model-viewer.min.js'
          )
          if (window.innerWidth > 992) {
            this.modelViewer = true
          }
        } catch (error) {
          console.error('Model viewer yüklenemedi:', error)
        }
      }
    },
  },
  mounted() {
    this.initModelViewer()
  },
}
